import React, { useRef, useState } from 'react';
import toastr from '../toastr';
import { modal } from '../modal/ModalEmitter';
import PrintLogToolbar from './PrintLogToolbar';
import PrintLogGrid from './PrintLogGrid';
import PrintLogGraph from './PrintLogGraph';
import Api from '../../services/ApiService';
import LoadingPage from '../LoadingPage';

import '../../styles/print.scss';

// confirm box will be triggered if altering many jobs
const confirmLimit = 100;

const PrintLog = () => {
  const [loading, setLoading] = useState(false);
  const printLogGrid = useRef(null);

  const getSelectedRows = () => {
    const rows = gridRef().gridApi.getSelectedRows();
    if (!rows || !rows.length) {
      toastr.warning('No rows selected');
      return null;
    }

    return rows;
  };

  const gridRef = () => printLogGrid.current;

  const deselectRows = () => {
    gridRef().gridApi.deselectAll();
  };

  const handleSearch = data => {
    gridRef().setRowData(data);
  };

  const handleCancelJobs = () => {
    const rows = getSelectedRows();
    if (rows) {
      const callback = () => {
        toastr.info(`Canceling ${rows.length} jobs`);
        Api.post('print/jobs/cancel', { ids: rows.map(r => r.id) }).then(deselectRows);
      };
      if (rows.length >= confirmLimit) {
        modal.confirm({ callback, message: `Cancel ${rows.length} jobs?` });
      } else {
        callback();
      }
    }
  };

  const handleRetryJobs = () => {
    const rows = getSelectedRows();
    if (!rows) {
      return;
    }
    const callback = () => {
      toastr.info(`Retrying ${rows.length} jobs`);
      Api.post('print/jobs/retry', { ids: rows.map(r => r.id) }).then(deselectRows);
    };

    if (rows.length >= confirmLimit) {
      modal.confirm({ callback, message: `Retry ${rows.length} jobs?` });
    } else {
      callback();
    }
  };

  const handleResubmitJobs = () => {
    const rows = getSelectedRows();
    if (!rows) {
      return;
    }
    const callback = () => {
      toastr.info(`Resubmiting ${rows.length} jobs`);
      Api.post('print/jobs/resubmit', { ids: rows.map(r => r.id) }).then(deselectRows);
    };

    if (rows.length >= confirmLimit) {
      modal.confirm({ callback, message: `Resubmit ${rows.length} jobs?` });
    } else {
      callback();
    }
  };

  const handleReindexSearch = () => {
    modal.confirm({
      callback: () => {
        setLoading(true);
        Api.post('search/PrintJob/reindex').then(() => {
          location.reload();
        });
      },
      message: 'Reindexing can potentially take a long time.',
    });
  };

  if (loading) {
    return <LoadingPage />;
  }

  return (
    <div id="list-container" className="content-container printlog-container">
      <PrintLogGraph />
      <PrintLogToolbar
        handleSearch={handleSearch}
        handleCancelJobs={handleCancelJobs}
        handleRetryJobs={handleRetryJobs}
        handleResubmitJobs={handleResubmitJobs}
        handleReindexSearch={handleReindexSearch}
      />
      <PrintLogGrid ref={printLogGrid} />
    </div>
  );
};

export default PrintLog;
